import {
  ActionIcon,
  Button,
  Card,
  Center,
  createStyles,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Select,
  SimpleGrid,
  Table,
  Text,
  TextInput,
  UnstyledButton,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconChevronDown, IconChevronUp, IconSelector } from "@tabler/icons";
import axios from "axios";
import { customLoader } from "components/utilities/loader";
import { Fragment, useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Search, Trash } from "tabler-icons-react";

import Controls from "components/controls/Controls";
import { API, formatNumber, PAGE_SIZE_OPTIONS } from "utiles/url";

const useStyles = createStyles((theme) => ({
  th: {
    padding: "0 !important",
  },

  control: {
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  icon: {
    width: 21,
    height: 21,
    borderRadius: 21,
  },
  thh: {
    color: "#666666",
    fontFamily: "'__Inter_aaf875','__Inter_Fallback_aaf875'",
    fontSize: "10px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
}));

function Th({ children, sortable, sorted, reversed, onSort }) {
  const { classes } = useStyles();
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  return (
    <th className={classes.th}>
      <UnstyledButton
        onClick={sortable ? onSort : null}
        className={classes.control}
      >
        <Group position="apart">
          <Text weight={500} size="sm">
            {children}
          </Text>
          {sortable && (
            <Center className={classes.icon}>
              <Icon size={14} stroke={1.5} />
            </Center>
          )}
        </Group>
      </UnstyledButton>
    </th>
  );
}

const Feedbacks = () => {
  const { classes } = useStyles();
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [deleteID, setDeleteID] = useState(false);
  const [search, setSearch] = useState("");
  const [sortedData, setSortedData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [size, setSize] = useState("10");
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
    fetchData(newSize);
  };
  useEffect(() => {
    fetchData(size);
  }, []);

  const fetchData = async (size) => {
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${API}/feedbacks?page=${activePage}&first=${size}`,
        config,
      );
      if (response.data) {
        setDrivers(response.data.data);
        setSortedData(response.data.data); // Ensure sorting is applied when data is fetched
        setTotal(response.data?.links);
        setTotalPages(response.data.paginatorInfo.lastPage);
        setTotalRecords(response.data.paginatorInfo.total);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearchChange = (event) => {
    const { value } = event.currentTarget;
    setSearch(value);
    setSortedData(
      sortData(drivers, {
        sortBy,
        reversed: reverseSortDirection,
        search: value,
      }),
    );
  };

  const sortData = (data, payload) => {
    if (!payload.sortBy) {
      return filterData(data, payload.search);
    }

    return filterData(
      [...data].sort((a, b) => {
        if (payload.reversed) {
          return b[payload.sortBy].localeCompare(a[payload.sortBy]);
        }

        return a[payload.sortBy].localeCompare(b[payload.sortBy]);
      }),
      payload.search,
    );
  };

  const handleChange = (page) => {
    setActivePage(page);
    fetchData(size);
  };

  const handleSort = (field) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    setSortedData(sortData(drivers, { sortBy: field, reversed, search }));
  };

  const filterData = (data, search) => {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
      Object.keys(item).some(
        (key) =>
          typeof item[key] === "string" &&
          item[key] &&
          item[key].toLowerCase().includes(query),
      ),
    );
  };
  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteFeedback = async () => {
    console.log("aaaa");
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.delete(
        `${API}/feedbacks/${deleteID}`,
        config,
      );
      console.log(response);
      if (response) {
        fetchData(size);
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Driver Deleted Successfully",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOpenedDelete(false);
      setDeleteID(null);
      showNotification({
        color: "red",
        title: "Error",
        message: `Driver Not Deleted Successfully`,
      });
    }
  };

  const theme = useMantineTheme();
  const rows = sortedData?.map((row) => (
    <Fragment key={row.id}>
      <tr>
        <td>{row.description}</td>
        <td>{row.user?.name}</td>
        <td>{row.user?.email}</td>
        <td>{row.user?.role}</td>
        <td>{row.feedback_type?.name}</td>
        <td>{new Date(row.created_at).toLocaleDateString()}</td>
        <td>
          <Controls.ActionButton
            color="primary"
            title="View Detail"
            //  onClick={() => handleDetail(element.feedbacks)}
          >
            <FiEye fontSize="medium" />
          </Controls.ActionButton>
          <Controls.ActionButton
            color="primary"
            title="Delete"
            onClick={() => handleDelete(`${row.id}`)}
          >
            <Trash size={17} />
          </Controls.ActionButton>
        </td>
      </tr>
    </Fragment>
  ));

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Card shadow="sm" p="lg">
        <ScrollArea>
          <SimpleGrid cols={3}>
            <div></div>
            <div></div>
            <div>
              <TextInput
                placeholder="Search by any field"
                mb="md"
                icon={<Search size={14} />}
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </SimpleGrid>
          <Table
            highlightOnHover
            horizontalSpacing="md"
            verticalSpacing="xs"
            sx={{ tableLayout: "fixed", minWidth: 700 }}
          >
            <thead>
              <tr style={{ backgroundColor: "#F1F1F1" }}>
                <Th sortable={false} onSort={() => handleSort("description")}>
                  <span className={classes.thh}> Description </span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("type")}>
                  <span className={classes.thh}> Type</span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("type")}>
                  <span className={classes.thh}> Name</span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("type")}>
                  <span className={classes.thh}> Email</span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("type")}>
                  <span className={classes.thh}> Role</span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("created_at")}>
                  <span className={classes.thh}> Date</span>
                </Th>
                <Th sortable={false} onSort={() => handleSort("created_at")}>
                  <span className={classes.thh}> Actions</span>
                </Th>
              </tr>
            </thead>
            <tbody>
              {rows?.length > 0 ? (
                rows
              ) : (
                <tr>
                  <td colSpan={8}>
                    <Text weight={500} align="center">
                      Nothing found
                    </Text>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "12px",
              padding: "6px 4px",
              borderTop: "1px solid #e9ecef",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {/* Left: Total Records */}
            <Text size="sm" style={{ color: "#FF6A00" }}>
              {`Total Records: ${formatNumber(totalRecords)}`}
            </Text>

            {/* Right: Rows select + navigation */}
            <Group spacing={6} noWrap>
              <Text size="sm" color="dimmed">
                Rows
              </Text>
              <Select
                value={size}
                onChange={handlePageSizeChange}
                data={PAGE_SIZE_OPTIONS}
                style={{ width: 72 }}
                size="xs"
              />
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(1)}
                disabled={activePage <= 1}
                title="First page"
                style={{ fontWeight: 700 }}
              >
                «
              </ActionIcon>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(activePage - 1)}
                disabled={activePage <= 1}
                title="Previous page"
              >
                ‹
              </ActionIcon>
              <Text size="sm" style={{ minWidth: 40, textAlign: "center" }}>
                {activePage} / {totalPages}
              </Text>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(activePage + 1)}
                disabled={activePage >= totalPages}
                title="Next page"
              >
                ›
              </ActionIcon>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(totalPages)}
                disabled={activePage >= totalPages}
                title="Last page"
                style={{ fontWeight: 700 }}
              >
                »
              </ActionIcon>
            </Group>
          </div>
        </ScrollArea>
        <Modal
          opened={openedDelete}
          onClose={() => setOpenedDelete(false)}
          title="Warning"
          centered
        >
          <p>Are you sure do you want todelete this data?</p>
          <Group position="right">
            <Button onClick={() => deleteFeedback()} color="red">
              Delete
            </Button>
          </Group>
        </Modal>
      </Card>
    </div>
  );
};

export default Feedbacks;
